import {
  Divider,
  List,
  ListItem,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import { ResourceVisitState } from "../redux/state";
import { HistoryListItem } from "./HistoryListItem";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
  },
}));

export const HistoryList: React.FC<{
  resourceVisitsState: ResourceVisitState;
}> = ({ resourceVisitsState }) => {
  const classes = useStyles();

  const { resourceVisits } = resourceVisitsState;
  return (
    <Paper className={classes.root} square>
      <List>
        {resourceVisits ? (
          <>
            {resourceVisits.length ? (
              resourceVisits.map((visit) => (
                <HistoryListItem key={visit.id} item={visit} />
              ))
            ) : (
              <Typography
                variant="h4"
                style={{ textAlign: "center", textTransform: "uppercase" }}
                color="textSecondary"
              >
                None
              </Typography>
            )}
          </>
        ) : (
          <>
            <ListItem>
              <Skeleton width="100%" height={40} animation={false} />
            </ListItem>
            <Divider />
            <ListItem>
              <Skeleton width="100%" height={40} animation={false} />
            </ListItem>
            <Divider />
            <ListItem>
              <Skeleton width="100%" height={40} animation={false} />
            </ListItem>
          </>
        )}
      </List>
    </Paper>
  );
};
